// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__xSTxh","log":"ModalInventoryLogs_log__1oOuQ","date":"ModalInventoryLogs_date__3CqDp","userName":"ModalInventoryLogs_userName__c6_Rn"};